<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="toggleWantClose()">
        <div class="modal-container-create" @click.stop>
          <div class="modal-header-create">
            {{ titres[contenuMontre[indexContenuMontre]] }}
            <slot name="cross">
              <v-icon
                style="float: right; top: 0.3vh"
                @click="toggleWantClose()"
                >mdi-close</v-icon
              >
              <v-icon
                v-if="indexContenuMontre > 0"
                style="float: right; margin-right: 1vw; top: 0.3vh"
                @click="previousContent()"
                >mdi-arrow-left</v-icon
              >
            </slot>
          </div>

          <div class="modal-body-create">
            <BodyDescription
              v-if="contenuMontre[indexContenuMontre] === 0"
              :initDescr="donneesAudit[contenuMontre[indexContenuMontre]]"
              @disable="disable"
              @enable="enable"
              @answer="getAnswer($event)"
            ></BodyDescription>
            <BodyRampants
              v-if="contenuMontre[indexContenuMontre] === 1"
              :initRampants="donneesAudit[contenuMontre[indexContenuMontre]]"
              :calepinage="donneesAudit[5]"
              @disable="disable"
              @enable="enable"
              @answer="getAnswerAndCalepinage($event)"
            ></BodyRampants>
            <BodyOnduleur
              v-if="contenuMontre[indexContenuMontre] === 2"
              :install_id="install_id"
              :initOnduleurs="donneesAudit[contenuMontre[indexContenuMontre]]"
              :initHistorique="donneesAudit[4]"
              :initCalepinage="donneesAudit[5]"
              @disable="disable"
              @enable="enable"
              @answer="getAnswerCaplepinageAndHistorique($event)"
            ></BodyOnduleur>
            <BodyModule
              v-if="contenuMontre[indexContenuMontre] === 3"
              :install_id="install_id"
              :initModules="donneesAudit[contenuMontre[indexContenuMontre]]"
              :initCalepinage="donneesAudit[5]"
              @disable="disable"
              @enable="enable"
              @answer="getAnswerAndCalepinage($event)"
            ></BodyModule>
            <BodyHistorique
              v-if="contenuMontre[indexContenuMontre] === 4"
              :initHistorique="donneesAudit[contenuMontre[indexContenuMontre]]"
              :initCalepinage="donneesAudit[5]"
              :onduleurs="donneesAudit[2]"
              @disable="disable"
              @enable="enable"
              @answer="getAnswerAndCalepinage($event)"
            ></BodyHistorique>
            
            <BodyCalepinage
              v-if="contenuMontre[indexContenuMontre] === 5"
              :install_id="install_id"
              :initCalepinage="donneesAudit[contenuMontre[indexContenuMontre]]"
              :historiqueOnduleurs="donneesAudit[4]"
              :onduleurs="donneesAudit[2]"
              :rampants="donneesAudit[1]"
              :modules="donneesAudit[3]"
              :initialTypeConfig="configurationType"
              @disable="disable"
              @enable="enable"
              @answer="getAnswer($event)"
            ></BodyCalepinage>
            
            <BodyDonnees
              v-if="contenuMontre[indexContenuMontre] === 6"
              :install_id="install_id"
              :initDonnee="donneesAudit[contenuMontre[indexContenuMontre]]"
              :prm="donneesAudit[0]?.prm"
              @disable="disable"
              @enable="enable"
              @answer="getAnswer($event)"
            ></BodyDonnees>
          </div>

          <div class="modal-footer-create">
            <v-btn
              v-if="indexContenuMontre === contenuMontre.length - 1"
              :loading="loading"              
              :disabled="suivantInactif || loading || !canValidate"            
              style="
                float: right;
                background-color: #f49301;
                padding: 1vh;
                font-size: 1.8vh;
              "
              @click="createAudit()"
            >
              {{ $t("_soumettre_fin_") }}
            </v-btn>

            <v-btn
              v-else
              :disabled="!canValidate || suivantInactif"
              style="
                float: right;
                background-color: #f49301;
                padding: 1vh;
                font-size: 1.8vh;
              "
              @click="nextContent()"
            >
              {{ $t("_suivant_") }}
            </v-btn>

            <v-btn
              v-if="this.type === 'create'"
              style="
                float: right;
                background-color: #d9d9d9;
                padding: 1vh;
                margin-right: 1vw;
                font-size: 1.8vh;
              "
              @click="toggleSave()"
            >
              {{ $t("_enregistrer_et_quitter_") }}
            </v-btn>
            <LoadingDialog v-if="loading" :is_loading="loading" />
          </div>
          <PopUpEnregistrer
            v-if="this.modalEnregistrer"
            @close="toggleSave()"
            @save="saveDraft($event)"
          >
          </PopUpEnregistrer>
          <PopUpValider
            v-if="this.modalFermer"
            @close="toggleWantClose()"
            @confirm="$emit('close')"
            @save="toggleSave()"
          ></PopUpValider>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import BodyRampants from "@/components/Creation/BodyRampants.vue";
import BodyDescription from "@/components/Creation/BodyDescription.vue";
import BodyOnduleur from "./BodyOnduleur.vue";
import BodyModule from "./BodyModule.vue";
import BodyHistorique from "./BodyHistorique.vue";
import BodyCalepinage from "./BodyCalepinage.vue";
import PopUpEnregistrer from "./PopUpEnregistrer.vue";
import PopUpValider from "./PopUpValider.vue";
import BodyDonnees from "./BodyDonnees.vue";
import LoadingDialog from "@/components/Utils/LoadingDialog";
import api from "@/api/api";
import "../../assets/css/style.css";

export default {
  components: {
    BodyRampants,
    BodyDescription,
    BodyOnduleur,
    BodyModule,
    BodyHistorique,
    BodyCalepinage,
    PopUpEnregistrer,
    PopUpValider,
    BodyDonnees,
    LoadingDialog,
  },

  props: {
    type: { required: true },
    data: { required: false },
    installAModif: { required: false },
  },

  async mounted() {
    switch (this.type) {
      case "create":
        this.contenuMontre = [0, 1, 2, 3, 4, 5, 6];
        break;
      case "modifier":
        this.contenuMontre = [0, 1, 2, 3, 4, 5, 6];
        this.modification = true;
        break;
      case "onduleur":
        this.contenuMontre = [2, 4, 5];
        this.modification = true;
        break;
      case "rampant":
        this.contenuMontre = [1, 5];
        this.modification = true;
        break;
      case "calepinage":
        this.contenuMontre = [5];
        this.modification = true;
        break;
    }
    this.utilisateur = (await api.currentUser()).data.id;
    this.getData();
  },

  data() {
    return {
      prm:null,
      canValidate: false, // Sécurité par défaut
      modification: false,
      suivantInactif: true,
      loading: false,
      contenuMontre: [],
      indexContenuMontre: 0,
      titres: [
        this.$t("_description_du_site_"),
        this.$t("_inventaire_des_rampants_"),
        this.$t("_inventaire_des_onduleurs_"),
        this.$t("_inventaire_des_module_"),
        this.$t("_historique_des_onduleurs_"),
        this.$t("_calepinage_"),
        this.$t("_source_donnees_production_"),
      ],
      donneesAudit: [],
      donneesProductionSource: null,
      files: {},
      modalEnregistrer: false,
      modalFermer: false,
      install_id: null,
      utilisateur: null,
      configurationType: "onduleur",
    };
  },

  methods: {
    nextContent() {
      this.indexContenuMontre += 1;
      // On bloque par défaut le suivant pour la prochaine étape en attendant que l'enfant l'active
      this.suivantInactif = true;
    },
    previousContent() {
      this.indexContenuMontre--;
    },

    // --- C'est ici que la magie opère ---
    disable(isValidationError) {
      this.suivantInactif = true;
      // Si l'enfant (ex: BodyCalepinage) signale une incohérence (rouge)
      // on passe canValidate à false, ce qui bloque le bouton Suivant
      if (isValidationError === 'coherence') {
        this.canValidate = false;
      }
    },
    enable() {
      this.suivantInactif = false;
      this.canValidate = true; // Tout est vert, on débloque le bouton Suivant
    },
    // ------------------------------------

    toggleSave() {
      if (!this.data && !this.modification) {
        this.modalFermer = false;
        this.modalEnregistrer = !this.modalEnregistrer;
      } else {
        this.saveDraft(this.data ? this.data.name : "");
      }
    },

    async saveDraft(nom) {
      try {
        if (this.modification) {
          await this.createAudit();
          return;
        }

        const donneesAvecConfig = {
          description: this.donneesAudit[0] || {},
          rampants_inventory: this.donneesAudit[1] || [],
          inverters_inventory: this.donneesAudit[2] || [],
          modules_inventory: this.donneesAudit[3] || [],
          history: this.donneesAudit[4] || [],
          layouts: this.donneesAudit[5] || [],
          configuration_type: this.configurationType,
        };

        if (this.data && this.data.id) {
          await api.put_draft_to_id(
            this.utilisateur,
            this.data.id,
            this.data.name,
            this.install_id,
            donneesAvecConfig
          );
        } else {
          const nomFinal = nom || "Brouillon du " + new Date().toLocaleString();
          await api.post_new_draft(
            this.utilisateur,
            nomFinal,
            this.install_id,
            donneesAvecConfig
          );
        }

        if (this.files.nouvelleDonnees) {
          // logique fichier
        }

        this.modalEnregistrer = false;
        this.modalFermer = false;
        this.$emit("close");
      } catch (error) {
        console.error("Erreur lors de la sauvegarde du brouillon :", error);
      }
    },

    toggleWantClose() {
      this.modalFermer = !this.modalFermer;
    },

    getAnswer(reponse) {
      if (this.contenuMontre[this.indexContenuMontre] === 6) {
        this.donneesProductionSource = reponse;
        this.$set(this.donneesAudit[0], "prm", reponse.enedis.prm);        
      } else if (this.contenuMontre[this.indexContenuMontre] === 5) {
        if (reponse && reponse.calepinage) {
          this.donneesAudit[5] = reponse.calepinage;
          if (reponse.typeConfig) this.configurationType = reponse.typeConfig;
        } else {
          this.donneesAudit[5] = reponse;
        }
      } else {
        this.donneesAudit[this.contenuMontre[this.indexContenuMontre]] =
          reponse;
      }
    },

    getAnswerAndCalepinage(reponse) {
      this.donneesAudit[this.contenuMontre[this.indexContenuMontre]] =
        reponse.reponse;
      if (reponse.calepinage !== undefined) {
        this.donneesAudit[5] =
          reponse.calepinage.calepinage || reponse.calepinage;
        if (reponse.calepinage.typeConfig)
          this.configurationType = reponse.calepinage.typeConfig;
      }
    },

    getAnswerCaplepinageAndHistorique(reponse) {
      this.donneesAudit[this.contenuMontre[this.indexContenuMontre]] =
        reponse.reponse;
      if (reponse.calepinage !== undefined) {
        this.donneesAudit[5] =
          reponse.calepinage.calepinage || reponse.calepinage;
        if (reponse.calepinage.typeConfig)
          this.configurationType = reponse.calepinage.typeConfig;
      }
      if (reponse.historique !== undefined)
        this.donneesAudit[4] = reponse.historique;
    },

    async audit_creation_post(install_id, donneesAudit, sourceDeDonnees) {
      const form_data = {
        description: donneesAudit[0],
        rampants_inventory: donneesAudit[1],
        inverters_inventory: donneesAudit[2],
        modules_inventory: donneesAudit[3],
        history: donneesAudit[4],
        layouts: donneesAudit[5],
        production_data_source: sourceDeDonnees,
        configuration_type: this.configurationType,
      };
      const res = await api.put_audit_creation(install_id, form_data);
      return res.data;
    },

    async createAudit() {
      if (this.loading) return;

      this.loading = true;
      try {
        if (this.modification && this.type !== "modifier") {
          for (let frag in this.contenuMontre) {
            let donneesSauvegarde = this.donneesAudit;
            if (this.contenuMontre[frag] === 5) {
              donneesSauvegarde[5] = {
                layouts: this.donneesAudit[5],
                configuration_type: this.configurationType,
              };
            }
            await api.put_install_form_frag(
              this.install_id,
              this.contenuMontre[frag],
              donneesSauvegarde
            );
          }
        } else {
          let res = await this.audit_creation_post(
            this.install_id,
            this.donneesAudit,
            this.donneesProductionSource
          );
          if (res && res.success && this.data) {
            await api.delete_draft_from_id(this.utilisateur, this.data.id);
          }
        }
        this.$emit("close");
      } catch (error) {
        console.error("Error creating audit:", error);
      } finally {
        this.loading = false;
      }
    },

    async getData() {
      if (this.modification) {
        this.install_id = this.installAModif;
        try {
          const reponse = (await api.get_install_form(this.installAModif)).data;
          this.donneesAudit = [
            reponse.description,
            reponse.rampants_inventory,
            reponse.inverters_inventory,
            reponse.modules_inventory,
            reponse.history,
            reponse.layouts,
            reponse.production_data_source || null,
          ];
          if (reponse.configuration_type)
            this.configurationType = reponse.configuration_type;
        } catch {
          this.donneesAudit = [{}, [], [], [], [], [], null];
        }
      } else {
        if (this.data != null) {
          const jd = this.data.json_data || {};
          this.donneesAudit = [
            jd.description || {},
            jd.rampants_inventory || [],
            jd.inverters_inventory || [],
            jd.modules_inventory || [],
            jd.history || [],
            jd.layouts || [],
            jd.production_data_source || null,
          ];
          this.install_id = this.data.install_id;
          if (this.data.configuration_type)
            this.configurationType = this.data.configuration_type;
        } else {
          this.install_id = (await api.claim_new_install_id()).data.install_id;
          this.donneesAudit = [{}, [], [], [], [], [], null];
        }
      }
      this.$forceUpdate();
    },
  },

  watch: {
    data: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    installAModif: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.modal-container-create {
  width: 90vw;
  height: 80vh;
  margin: 0px auto;
  padding: 2vh;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  border-radius: 0.25rem;
  position: relative;
  /* display: grid; */
  flex-direction: column;
}

.modal-header-create {
  font-weight: bold;
  font-size: 1.5rem;
  color: #212121;
  height: fit-content;
}

.modal-body-create {
  overflow-y: auto;
  overflow-x: hidden;
  height: 88%;
}

.modal-footer-create {
  padding: 16px 16px;
  background-color: white;
  color: white;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
